/**
 * @param   {string} title
 * @returns {string}
 */
export default (title) => title?.trim().split(' ').map((e) => e[0].toUpperCase() + e.substring(1)).join(' ');
